import { z } from 'zod';

import { LanguageEnum } from '../../enums';
import { languageEnumValidator } from '../../validators';

export const EvaluateShortAnswerFromTextSchema = z.object({
  language: languageEnumValidator
    .optional()
    .default(LanguageEnum.RU)
    .describe('The language for the feedback. Defaults to RU if not provided.'),
  question: z.string().min(1).describe('The question that was asked'),
  text: z.string().min(1).describe('The context text for the evaluation'),
  userAnswer: z.string().min(1).describe('The answer provided by the user'),
});

export type IEvaluateShortAnswerFromTextDto = z.infer<
  typeof EvaluateShortAnswerFromTextSchema
>;
